// extracted by mini-css-extract-plugin
export default {"max-width":"Hotline_max-width__9sdju","title":"Hotline_title__cglsk","note":"Hotline_note__hOUln","row":"Hotline_row__rYYD4","btn":"Hotline_btn__0D1Lt"};